import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ec72bb3c = () => interopDefault(import('../pages/thank-you.vue' /* webpackChunkName: "pages/thank-you" */))
const _716f4710 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/thank-you",
    component: _ec72bb3c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you"
  }, {
    path: "/co/digital-learning",
    component: _716f4710,
    pathToRegexpOptions: {"strict":true},
    name: "index___co"
  }, {
    path: "/en/digital-learning",
    component: _716f4710,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/en/thank-you",
    component: _ec72bb3c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you___en"
  }, {
    path: "/es-co/digital-learning",
    component: _716f4710,
    pathToRegexpOptions: {"strict":true},
    name: "index___es-co"
  }, {
    path: "/es-es/digital-learning",
    component: _716f4710,
    pathToRegexpOptions: {"strict":true},
    name: "index___es-es"
  }, {
    path: "/es-es/thank-you",
    component: _ec72bb3c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you___es-es"
  }, {
    path: "/es-mx/digital-learning",
    component: _716f4710,
    pathToRegexpOptions: {"strict":true},
    name: "index___es-mx"
  }, {
    path: "/es/digital-learning",
    component: _716f4710,
    pathToRegexpOptions: {"strict":true},
    name: "index___es"
  }, {
    path: "/es/thank-you",
    component: _ec72bb3c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you___es"
  }, {
    path: "/la/digital-learning",
    component: _716f4710,
    pathToRegexpOptions: {"strict":true},
    name: "index___la"
  }, {
    path: "/mx/digital-learning",
    component: _716f4710,
    pathToRegexpOptions: {"strict":true},
    name: "index___mx"
  }, {
    path: "/pt-br/hotmartacademy",
    component: _716f4710,
    pathToRegexpOptions: {"strict":true},
    name: "index___pt-br"
  }, {
    path: "/pt-br/thank-you",
    component: _ec72bb3c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you___pt-br"
  }, {
    path: "/co/digital-learning/gracias",
    component: _ec72bb3c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you___co"
  }, {
    path: "/es-co/digital-learning/gracias",
    component: _ec72bb3c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you___es-co"
  }, {
    path: "/es-mx/digital-learning/gracias",
    component: _ec72bb3c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you___es-mx"
  }, {
    path: "/la/digital-learning/gracias",
    component: _ec72bb3c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you___la"
  }, {
    path: "/mx/digital-learning/gracias",
    component: _ec72bb3c,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you___mx"
  }, {
    path: "/",
    component: _716f4710,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
